import React, { useState } from "react";
import { uploadToS3 } from "@/lib/api";
import { Upload, X, Loader2 } from "lucide-react";

/**
 * Uploader for a single image or video to S3 via signed backend.
 * onChange({ url, public_id, storage_key, media_id }).
 */
export default function MediaUploader({
  value, onChange,
  resourceType = "image",
  folder = "uploads",
  weddingSlug, purpose, association,
  label = "Upload media",
  testId,
}) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true); setErr("");
    try {
      const media = await uploadToS3(file, resourceType, { folder, weddingSlug, purpose, association });
      onChange({
        url: media.url,
        public_id: media.storage_key,
        storage_key: media.storage_key,
        media_id: media.id,
      });
    } catch (e2) {
      setErr(e2.message);
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <div>
      <div className="flex items-center gap-3">
        <label data-testid={testId} className="btn-pill btn-outline cursor-pointer !py-2 !px-4 text-[10px]">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />}
          {label}
          <input
            type="file"
            className="hidden"
            accept={resourceType === "video" ? "video/*" : "image/*"}
            onChange={handleFile}
          />
        </label>
        {value?.url && (
          <>
            {resourceType === "image" ? (
              <img src={value.url} alt="" className="w-14 h-14 object-cover rounded" />
            ) : (
              <video src={value.url} className="w-14 h-14 object-cover rounded" muted preload="metadata" />
            )}
            <button type="button" onClick={() => onChange({ url: "", public_id: null, storage_key: null, media_id: null })} className="text-[color:var(--text-muted)] hover:text-red-400">
              <X size={16} />
            </button>
          </>
        )}
        <input
          type="text"
          placeholder="…or paste URL"
          value={value?.url || ""}
          onChange={(e) => onChange({ url: e.target.value, public_id: null, storage_key: null, media_id: null })}
          className="flex-1 bg-transparent border border-[color:var(--border)] px-3 py-2 text-xs text-[color:var(--text)] outline-none focus:border-[color:var(--accent)]"
        />
      </div>
      {err && <div className="text-red-400 text-xs mt-2">{err}</div>}
    </div>
  );
}
